import React, { useState, useEffect } from 'react';

const TICKER_MESSAGES = [
  { icon: '🚚', text: 'FREE SHIPPING on orders above ₹299' },
  { icon: '🔥', text: 'SALE — Up to 23% off on Packs!' },
  { icon: '⚡', text: 'Limited Time Offer — Buy Now!' },
];

export function TickerBar() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex(i => (i + 1) % TICKER_MESSAGES.length);
        setVisible(true);
      }, 400);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const msg = TICKER_MESSAGES[index];
  return (
    <div className="ticker-bar">
      <span className={`ticker-item${visible ? ' ticker-in' : ' ticker-out'}`}>
        {msg.icon} {msg.text}
      </span>
    </div>
  );
}
